/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskObjectivesDimensions } from './taskObjectivesDimensions';

/**
 * Task objectives for each evaluation dimension
 */
export interface TaskObjectives {
  /** For each dimensions: is it applicable (bool) and which demands fall under this dimension */
  dimensions: TaskObjectivesDimensions;
}
